/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TenantCreationPostSpec { 
    org_id: string;
    erp_id?: string;
    /**
     * True if org has tib subscription, false otherwise
     */
    has_deployment: boolean;
    /**
     * Last processing date saved by VLR daily org summary
     */
    vlr_org_summary_last_processing_dt?: string;
    /**
     * Last processing date saved by VMC daily org summary
     */
    vmc_org_summary_last_processing_dt?: string;
    /**
     * Last reconcile/refresh date saved by VMC daily org summary
     */
    last_vmc_refresh_dt?: string;
    licensee_name?: string;
    licensee_classification?: string;
    licensee_sales_region?: string;
    parent_account_name?: string;
    rpt_geo?: string;
    earliest_start_date_vm?: string;
    latest_end_date_vm?: string;
    earliest_start_date_tib?: string;
    latest_end_date_tib?: string;
    technical_contact?: string;
    tech_contact_email_address?: string;
    end_cust_country_code?: string;
}

